/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Shipping_Notice_Short1Inputs */

const vi_sitesettings_product_shipping_notice_short1 = /** @type {(inputs: Sitesettings_Product_Shipping_Notice_Short1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú phí vận chuyển (điện thoại, Mini App)`)
};

/**

* @param {Sitesettings_Product_Shipping_Notice_Short1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_shipping_notice_short1 = /** @type {((inputs?: Sitesettings_Product_Shipping_Notice_Short1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Shipping_Notice_Short1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_shipping_notice_short1(inputs)
});
export { sitesettings_product_shipping_notice_short1 as "siteSettings_product_shipping_notice_short" }